import { useAuth } from '../context/AuthContext.js';
import darLogoBlue from '../assets/darlings-logo-blue.png';
import loginBg from '../assets/login-bg.webp';

export function LoginPage(): React.JSX.Element {
  const { login, error } = useAuth();

  return (
    <div
      className="min-h-screen bg-white flex items-center justify-center px-4 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${loginBg})` }}
    >
      <div className="bg-white rounded-2xl shadow-xl p-10 w-full max-w-md text-center">
        <img src={darLogoBlue} alt="Darling's Auto Group" className="h-14 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Pay Plan Manager</h1>
        <p className="text-sm text-gray-500 mb-8">Sign in to manage compensation plans</p>

        {error !== null && error !== '' && (
          <div className="mb-6 rounded-lg bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
            {error}
          </div>
        )}

        <button
          type="button"
          onClick={() => {
            void login();
          }}
          className="w-full flex items-center justify-center gap-3 bg-gray-900 hover:bg-gray-800 text-white font-medium py-3 px-4 rounded-lg transition-colors"
        >
          <svg className="w-5 h-5" viewBox="0 0 21 21" fill="none">
            <rect x="1" y="1" width="9" height="9" fill="#F25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
            <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
          </svg>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
